import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSearchItemPerPageChangedParameters extends TrackEventBaseParameters<null, "item_per_page"> {}

const trackSearchItemPerPageChanged = (
    parameters: TrackSearchItemPerPageChangedParameters,
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.track.event({ action: "search_item_per_page_changed", ...parameters }, options);
};

export default trackSearchItemPerPageChanged;
